export default __webpack_public_path__ + "static/media/npm-2.ad11c6b4.svg";